import React, { PropsWithChildren } from 'react';
import DossierActionProvider from '@europrocurement/l2d-modules/modules/Dossiers/providers/DossierActionProvider';
import { DossierValidatorsProvider } from './DossierValidatorsProvider';
import { FormalitiesProvider } from './FormalitiesProvider';
import { FormulairesProvider } from './FormulairesProvider';
import { UsersProvider } from './UsersProvider';
import { TiersProvider } from './TiersProvider';
import { RegleCalculCategoriesProvider } from './RegleCalculCategoriesProvider';

import CurrentDossierProviderAndDocumentsWrapper from './CurrentDossierProviderAndDocumentsWrapper';
import { DriveDocumentsProvider } from './DriveDocumentsProvider';
import { OffresProvider } from './OffresProvider';
import { OriginesOffresProvider } from './OriginesOffresProvider';
import { DomainesProvider } from './DomainesProvider';

export type GlobalDataProviderProps = {
    formalities?: boolean;
    forms?: boolean;
    validators?: boolean;
    users?: boolean;
    regleCalculCategories?: boolean;
    offres?: boolean;
    originesOffres?: boolean;
    domaines?: boolean;
};

export const GlobalDataProvider: React.FunctionComponent<
    PropsWithChildren<GlobalDataProviderProps>
> = function ({
    formalities = true,
    forms = true,
    validators = true,
    users = true,
    regleCalculCategories = false,
    offres = true,
    originesOffres = true,
    domaines = true,
    children,
}) {
    return (
        <TiersProvider autoload={false}>
            <DossierValidatorsProvider autoload={validators}>
                <UsersProvider autoload={users}>
                    <FormalitiesProvider autoload={formalities}>
                        <FormulairesProvider autoload={forms}>
                            <RegleCalculCategoriesProvider autoload={regleCalculCategories}>
                                <OffresProvider autoload={offres}>
                                    <OriginesOffresProvider autoload={originesOffres}>
                                        <DomainesProvider autoload={domaines}>
                                            <CurrentDossierProviderAndDocumentsWrapper>
                                                <DossierActionProvider>
                                                    <DriveDocumentsProvider>
                                                        {children}
                                                    </DriveDocumentsProvider>
                                                </DossierActionProvider>
                                            </CurrentDossierProviderAndDocumentsWrapper>
                                        </DomainesProvider>
                                    </OriginesOffresProvider>
                                </OffresProvider>
                            </RegleCalculCategoriesProvider>
                        </FormulairesProvider>
                    </FormalitiesProvider>
                </UsersProvider>
            </DossierValidatorsProvider>
        </TiersProvider>
    );
};
